/* eslint-disable @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-argument, @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-member-access */
import React from 'react';
import _ from 'utils/lodash';
import { BTTStaff } from 'types/campaign';
import './inputStaff.scss';
import BttStaffSelect from '../offerEditor/bttStaffSelect';
import { Checkbox } from 'components/next/components/checkbox';

interface Props {
  value?: {
    title?: string;
    name: string;
    email: string;
    links: {
      url?: string;
      text?: string;
    }[];
    phoneNumber: string[];
    imageUrl?: string;
    imageName?: string;
    phoneSelected?: string;
    showBookingButton?: boolean;
    linkURLSelected?: string;
    linkTextSelected?: string;
  };
  onChange({
    title,
    name,
    email,
    links,
    phoneNumber,
    imageUrl,
    imageName,
    phoneSelected,
    showBookingButton,
    linkURLSelected,
    linkTextSelected,
  }: {
    title?: string;
    name: string;
    email: string;
    links: { url?: string; text?: string }[];
    phoneNumber: string[];
    imageUrl?: string;
    imageName?: string;
    phoneSelected?: string;
    showBookingButton?: boolean;
    linkURLSelected?: string;
    linkTextSelected?: string;
  }): void;
  label?: string;
  readOnly?: boolean;
  name: string;
}

interface State {
  local: {
    showBookingButton: boolean;
    title?: string;
    name: string;
    email: string;
    links: { url?: string; text?: string }[];
    phoneNumber: string[];
    imageUrl?: string;
    imageName?: string;
    phoneSelected?: string;
    linkURLSelected?: string;
    linkTextSelected?: string;
  };
}

class InputStaff extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      local: {
        ...props.value,
        links: props.value?.links ? [...props.value.links] : [],
        phoneNumber: props.value?.phoneNumber ? [...props.value.phoneNumber] : [],
        showBookingButton: props.value?.showBookingButton ?? true,
      },
    };
  }

  componentDidMount() {
    if (!this.props.readOnly && this.props.value?.name && this.props.value.showBookingButton === undefined) {
      this.props.onChange({ ...this.state.local });
    }
  }

  componentDidUpdate(prev: Props) {
    if (prev.value !== this.props.value) {
      this.setState({
        local: {
          ...this.props.value,
          links: this.props.value?.links ? [...this.props.value.links] : [],
          phoneNumber: this.props.value?.phoneNumber ? [...this.props.value.phoneNumber] : [],
          showBookingButton:
            this.props.value?.showBookingButton !== undefined
              ? this.props.value.showBookingButton
              : this.state.local.showBookingButton,
        },
      });
    }
  }

  emitChange(updatedLocal: State['local']) {
    this.setState({ local: updatedLocal });
    this.props.onChange(updatedLocal);
  }

  onStaffSelect = (s: BTTStaff) => {
    const payload = {
      name: s.name,
      title: s.title,
      email: s.email,
      phoneNumber: s.PhoneNumber,
      imageName: s.imageName,
      phoneSelected: s.phoneFirst,
      showBookingButton: s.showBookingButton ?? this.state.local.showBookingButton ?? true,
      linkURLSelected: s.links[0]?.url,
      linkTextSelected: s.links[0]?.text,
      imageUrl: s.imageUrl,
      links: s.links || [],
    };
    const updated = { ...(this.state.local || {}), ...payload };
    this.emitChange(updated);
  };

  handleFieldChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    const updated = { ...this.state.local, [name]: value };
    this.emitChange(updated);
  };

  render() {
    const v = this.state.local;
    return (
      <div className="staff-input">
        {this.props.label && <label>{this.props.label}</label>}

        {/* Dropdown for selecting staff */}
        <div className="form-control">
          <BttStaffSelect onSelect={this.onStaffSelect} placeholder="Kirjoita väh. 1 merkki..." />
        </div>

        <div className="form-control">
          <label>Asiantuntijan titteli</label>
          <input name="title" value={v.title || ''} onChange={this.handleFieldChange} readOnly={this.props.readOnly} />
        </div>

        <div className="form-control">
          <label>Asiantuntijan nimi</label>
          <input name="name" value={v.name || ''} onChange={this.handleFieldChange} readOnly={this.props.readOnly} />
        </div>

        <div className="form-control">
          <label>Asiantuntijan sähköposti</label>
          <input name="email" value={v.email || ''} onChange={this.handleFieldChange} readOnly={this.props.readOnly} />
        </div>

        <div className="form-control">
          <label>Asiantuntijan puhelinnumero</label>
          <input
            name="phoneSelected"
            value={v.phoneSelected || ''}
            onChange={this.handleFieldChange}
            readOnly={this.props.readOnly}
          />
        </div>

        <Checkbox
          label="Näytä ajanvarauspainike"
          id={`${this.props.name}-showBookingButton`}
          checked={v.showBookingButton ?? true}
          handleClick={(e) => {
            this.emitChange({ ...this.state.local, showBookingButton: e.target.checked });
          }}
          disabled={this.props.readOnly}
        />
        <div className="form-control" hidden>
          <label>Asiantuntijan linkki teksti</label>
          <input
            name="linkTextSelected"
            value={v.linkTextSelected || ''}
            onChange={this.handleFieldChange}
            readOnly={this.props.readOnly}
          />
        </div>

        <div className="form-control" hidden>
          <label>Asiantuntijan linkki</label>
          <input
            name="linkURLSelected"
            value={v.linkURLSelected || ''}
            onChange={this.handleFieldChange}
            readOnly={this.props.readOnly}
          />
        </div>

        <div className="form-control" hidden>
          <label>Asiantuntijan kuvan nimi</label>
          <input
            name="imageName"
            value={v.imageName || ''}
            onChange={this.handleFieldChange}
            readOnly={this.props.readOnly}
          />
        </div>

        <div className="form-control" hidden>
          <label>Asiantuntijan kuva linkki</label>
          <input
            name="imageUrl"
            value={v.imageUrl || ''}
            onChange={this.handleFieldChange}
            readOnly={this.props.readOnly}
          />
        </div>
      </div>
    );
  }
}

export default InputStaff;
